import * as React from "react";
import {Article} from "../../model/Article";
import "./magazine.css";

interface ArticleListItemProps {
    article: Article,
    buttonText: string,
    onClick: () => void
}

/**
 * format timestamp to date string.
 * @param timestamp
 */
const formatTimestampToDateString = (timestamp: number) => {
    const date: Date = new Date(timestamp * 1000);
    let dateString: string = date.getDate() + '.';
    if (date.getDate() < 10) {
        dateString = '0' + dateString;
    }
    if (date.getMonth() < 9) {
        dateString += '0';
    }
    return dateString + (date.getMonth() + 1) + '.' + date.getFullYear();
}

export default function ArticleListItem(props: ArticleListItemProps) {
    return <li className={"item"}>
        <div className={"inc-id"}>
            {props.article.incId}
        </div>
        <div className={"date"}>
            {formatTimestampToDateString(props.article.timestamp)}
        </div>
        {props.article.title}
        <button className={"right"}
                onClick={props.onClick}>{props.buttonText}
        </button>
    </li>;
}
